import React, { useEffect, useRef, useState } from 'react'
import { handleFocusNext } from 'utils/helpers'
import { Flex, InvalidText } from '../../styling/GlobalStyles'
import { InputIcon, InputWrapper, Label } from './Input.styled'
import { GreySearchIcon } from 'assets/icons/GreySearchIcon'

export const Input = (props) => {
  const p = { ...props }
  const inputRef = useRef(null)
  const wrapperRef = useRef(null)
  const { labelText, minHeight, nomarg, value, readOnly, required, rightIcon, onRightIconClick } = p
  delete p.labelText
  delete p.minHeight
  delete p.nomarg
  delete p.rightIcon
  delete p.onRightIconClick
  const [blured, setBlured] = useState(false)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.autocomplete = 'off'
    }
  }, [])

  let parsedValue;
  if (props.allowZero) {
    parsedValue = value == 0 ? '0' : (value || '')

  } else {
    parsedValue = value || ''

  }

  const handleBlur = () => {
    setBlured(true)
  }

  const renderInput = () => {
    if (p.smallInput) {
      return (
        <input
          {...p}
          onBlur={handleBlur}
          ref={inputRef}
          value={parsedValue}
          onKeyDown={handleFocusNext}
          style={{ pointerEvents: readOnly ? 'none' : 'all' }}
        />
      )
    }
    switch (p.type) {
      case 'textarea':
        return (
          <textarea
            onBlur={handleBlur}
            {...p}
            value={parsedValue}
          // onKeyDown={handleFocusNext}
          ></textarea>
        )
      case 'number':
        return (
          <input
            {...p}
            value={parsedValue}
            onBlur={handleBlur}
            autoComplete='new-password'
            onWheel={(event) => event.currentTarget.blur()}
            ref={inputRef}
            onKeyDown={handleFocusNext}
          />
        )
      case 'tel':
        return (
          <input
            {...p}
            value={parsedValue}
            type='tel'
            ref={inputRef}
            onBlur={handleBlur}
            onKeyDown={handleFocusNext}
          />
        )
      default:
        return (
          <input
            {...p}
            onBlur={handleBlur}
            autoComplete='new-password'
            style={p.search ? { paddingLeft: '3rem', paddingRight: rightIcon ? '3rem' : undefined } : {}}
            type={p.type ? p.type : 'text'}
            ref={inputRef}
            value={parsedValue}
            onKeyDown={handleFocusNext}
          />
        )
    }
  }


  return (
    <InputWrapper
      noPadding={p.type == 'color'}
      {...p}
      blured={blured ? 'true' : ''}
      minHeight={minHeight}
      nomarg={nomarg}
      ref={wrapperRef}
    >
      <Label labelText={labelText}>
        {labelText}
      </Label>
      {required && <span style={{ color: 'red' }} >*</span>}

      <div className='input' >
        {p.search && <InputIcon left><GreySearchIcon /></InputIcon>}
        {rightIcon && <InputIcon onClick={onRightIconClick}>{rightIcon}</InputIcon>}
        {renderInput()}
      </div>

      {!props.noinvalidtext && (
        <Flex width='100%' justend >
          <article>
            {p.invalid && blured && <InvalidText>{props.customInvalidMessage ?? 'Input is invalid or missing'}</InvalidText>}
          </article>
        </Flex>
      )}
    </InputWrapper>
  )
}
